// 校园吃瓜站点内容数据（静态展示用，非真实产品）
export interface GuaguaCategory {
  id: string;
  name: string;
  emoji: string;
  slogan: string;
  count: number;
  color: string; // tailwind text/bg helper hue key
  img: string;
}

export interface HotItem {
  rank: number;
  title: string;
  tag: string;
  heat: string;
  up: number;
}

export interface FeedItem {
  id: string;
  category: string;
  emoji: string;
  title: string;
  excerpt: string;
  author: string;
  school: string;
  time: string;
  likes: number;
  comments: number;
  hot: boolean;
}

export interface FaqItem {
  q: string;
  a: string;
}

export const guaguaCategories: GuaguaCategory[] = [
  {
    id: "dorm",
    name: "宿舍趣闻",
    emoji: "🛏️",
    slogan: "夜聊顶流、舍友整活，都在这一屋",
    count: 3260,
    color: "primary",
    img: "https://readdy.ai/api/search-image?query=playful%20flat%20illustration%20of%20a%20cozy%20college%20dorm%20room%20at%20night%2C%20students%20gossiping%20and%20laughing%20on%20bunk%20beds%2C%20warm%20coral%20red%20and%20soft%20cream%20palette%2C%20melon%20green%20accents%2C%20cute%20minimal%20vector%20style%2C%20friendly%20campus%20life%20scene&width=720&height=540&seq=dorm-guagua-01&orientation=landscape",
  },
  {
    id: "class",
    name: "课堂名场面",
    emoji: "🖍️",
    slogan: "点名、板书与整活，专治上课犯困",
    count: 2810,
    color: "accent",
    img: "https://readdy.ai/api/search-image?query=cheerful%20flat%20illustration%20of%20a%20sunny%20college%20classroom%2C%20students%20raising%20hands%20and%20giggling%20at%20a%20funny%20lecture%2C%20whiteboard%20with%20doodles%2C%20coral%20red%20melon%20green%20and%20cream%20palette%2C%20minimal%20cute%20vector%20art%2C%20lively%20campus%20scene&width=720&height=540&seq=class-guagua-02&orientation=landscape",
  },
  {
    id: "canteen",
    name: "食堂奇遇",
    emoji: "🍱",
    slogan: "打菜手抖与黑暗料理，干饭人的江湖",
    count: 1980,
    color: "secondary",
    img: "https://readdy.ai/api/search-image?query=whimsical%20flat%20illustration%20of%20a%20bustling%20college%20canteen%20food%20court%2C%20students%20in%20line%20with%20trays%2C%20colorful%20dishes%2C%20warm%20coral%20and%20cream%20tones%20with%20melon%20green%20detail%2C%20cute%20vector%20style%2C%20happy%20campus%20daily%20scene&width=720&height=540&seq=canteen-guagua-03&orientation=landscape",
  },
  {
    id: "club",
    name: "社团搞事",
    emoji: "🎪",
    slogan: "百团大战、活动整活，年轻人很会玩",
    count: 1520,
    color: "primary",
    img: "https://readdy.ai/api/search-image?query=energetic%20flat%20illustration%20of%20college%20club%20activities%20on%20campus%2C%20students%20doing%20fun%20skits%20and%20posters%2C%20colorful%20festival%20booth%2C%20coral%20melon%20green%20and%20cream%20palette%2C%20playful%20minimal%20vector%20art&width=720&height=540&seq=club-guagua-04&orientation=landscape",
  },
  {
    id: "exam",
    name: "期末求生",
    emoji: "📚",
    slogan: "复习周生存实录，谁都曾是熬夜冠军",
    count: 2400,
    color: "accent",
    img: "https://readdy.ai/api/search-image?query=funny%20flat%20illustration%20of%20college%20students%20cramming%20for%20finals%20in%20a%20library%2C%20coffee%20cups%20and%20notes%20everywhere%2C%20tired%20but%20humorous%20mood%2C%20soft%20cream%20background%20with%20melon%20green%20and%20coral%20accents%2C%20cute%20vector%20style&width=720&height=540&seq=exam-guagua-05&orientation=landscape",
  },
  {
    id: "love",
    name: "恋爱吃瓜",
    emoji: "💘",
    slogan: "表白墙与心动日常，甜瓜也不放过",
    count: 1720,
    color: "secondary",
    img: "https://readdy.ai/api/search-image?query=sweet%20flat%20illustration%20of%20young%20college%20couple%20on%20a%20blossom%20campus%20path%2C%20hearts%20and%20letter%20envelopes%20floating%2C%20romantic%20coral%20pink%20melon%20green%20cream%20palette%2C%20cute%20minimal%20vector%20style&width=720&height=540&seq=love-guagua-06&orientation=landscape",
  },
];

export const hotList: HotItem[] = [
  { rank: 1, title: "室友半夜放屁，硬说是我猫叫，可宿舍根本没有猫", tag: "宿舍趣闻", heat: "126.8万围观", up: 4320 },
  { rank: 2, title: "高数老师下课被学生拦下，以为要问问题，结果是请他吃瓜", tag: "课堂名场面", heat: "98.5万围观", up: 3870 },
  { rank: 3, title: "食堂阿姨手抖成习惯，同学说阿姨我一天没吃了，立刻满勺", tag: "食堂奇遇", heat: "86.2万围观", up: 3510 },
  { rank: 4, title: "社团纳新表演整活，社长当场社死，台下笑成一片", tag: "社团搞事", heat: "74.9万围观", up: 2960 },
  { rank: 5, title: "期末复习到凌晨三点，室友问：你在修仙吗？回：我在修学分", tag: "期末求生", heat: "63.4万围观", up: 2540 },
  { rank: 6, title: "表白墙投稿：在图书馆遇见crush，结果他看完书走了没认出我", tag: "恋爱吃瓜", heat: "52.7万围观", up: 2190 },
  { rank: 7, title: "班长统计身高，全班平均165，他默默报高3厘米，说怕拖后腿", tag: "宿舍趣闻", heat: "44.1万围观", up: 1860 },
  { rank: 8, title: "体育课跑步掉鞋，同学大喊老师他鞋掉了，全场憋笑到内伤", tag: "课堂名场面", heat: "38.9万围观", up: 1650 },
  { rank: 9, title: "食堂新菜：草莓炒肉，敢吃的都是勇士，排队的全是看热闹的", tag: "食堂奇遇", heat: "33.2万围观", up: 1420 },
  { rank: 10, title: "毕业前把四年趣事写成情书，寄给了曾经喜欢过的那个TA", tag: "毕业季", heat: "29.6万围观", up: 1380 },
];

export const feedItems: FeedItem[] = [
  {
    id: "f1",
    category: "宿舍趣闻",
    emoji: "🛏️",
    title: "室友的整活日常：半夜把寝室群改名叫『全员静音中』",
    excerpt: "昨晚十一点我还在赶作业，突然群里蹦出一句『全员静音中』，然后全寝在群里疯狂斗图，笑声把隔壁寝室都吵醒了过来敲门。这就是当代大学生的自律吗？",
    author: "爱嗦粉的柚子",
    school: "湖大",
    time: "12分钟前",
    likes: 862,
    comments: 129,
    hot: true,
  },
  {
    id: "f2",
    category: "课堂名场面",
    emoji: "🖍️",
    title: "老师提问冷场，我随口接了句『这题我女朋友会』，全班沉默了",
    excerpt: "本来是想缓解尴尬，结果话一出口我自己先尴尬了……关键是我根本没有女朋友。老师幽幽地补了一句：『那下课让你女朋友来讲。』这堂课上得我如坐针毡。",
    author: "半糖少冰",
    school: "川传",
    time: "45分钟前",
    likes: 1204,
    comments: 356,
    hot: true,
  },
  {
    id: "f3",
    category: "食堂奇遇",
    emoji: "🍱",
    title: "今天食堂阿姨给我打了一整勺红烧肉，原来是认错成隔壁院花了",
    excerpt: "排队打饭时阿姨突然朝我笑，热情地给我加满了一大勺肉，还说『姑娘你瘦了得多吃』。直到后面传来『院花来了』的喊声，我才明白这肉是借的光……",
    author: "今天也想吃饭",
    school: "湘大",
    time: "1小时前",
    likes: 958,
    comments: 201,
    hot: false,
  },
  {
    id: "f4",
    category: "社团搞事",
    emoji: "🎪",
    title: "动漫社招新现场，社长COS了一个谁都认不出的角色",
    excerpt: "纳新海报上写着『神秘嘉宾空降』，结果社长顶着个大纸箱上来，说这是刚觉醒的形态。直到有个学妹喊出正确的角色名，全场才爆发出『哇』声，笑疯了。",
    author: "次元穿越者",
    school: "电子科大",
    time: "2小时前",
    likes: 773,
    comments: 98,
    hot: true,
  },
  {
    id: "f5",
    category: "期末求生",
    emoji: "📚",
    title: "期末复习四件套：咖啡、眼药水、坐垫和一颗想死的决心",
    excerpt: "图书馆从早八坐到晚十，中途差点把对面桌学霸的笔记当成自己写的。考完那一刻，我觉得我能吃下整头牛，然后倒头睡到第二天下午。",
    author: "熬夜研究生",
    school: "重邮",
    time: "3小时前",
    likes: 1667,
    comments: 402,
    hot: true,
  },
  {
    id: "f6",
    category: "恋爱吃瓜",
    emoji: "💘",
    title: "表白墙投稿：喜欢的人给我送早餐，却是托室友带的",
    excerpt: "他说怕我起不来，特意让室友顺路带过来。虽然没明说，但寝室里的姐妹已经开始帮我脑补剧情了。这条投稿能不能火一下，让他看到呀？",
    author: "心动信号灯",
    school: "北师",
    time: "4小时前",
    likes: 2310,
    comments: 567,
    hot: true,
  },
  {
    id: "f7",
    category: "宿舍趣闻",
    emoji: "🛏️",
    title: "毕业前宿舍最后一次夜谈，聊到凌晨三点都舍不得睡",
    excerpt: "从军训聊到社团，从暗恋聊到挂科，原来四年的故事比想象中多得多。有人红了眼眶，有人偷偷计划着毕业旅行，这大概就是青春最好的样子吧。",
    author: "云淡风轻",
    school: "武大",
    time: "6小时前",
    likes: 2890,
    comments: 431,
    hot: true,
  },
  {
    id: "f8",
    category: "课堂名场面",
    emoji: "🖍️",
    title: "体育课八百米，最后五十米我走过去的，老师给我判了个『精神可嘉』",
    excerpt: "真不是我不想跑，是真的腿软到迈不动。老师看着我满脸写着『尽力了』，默默在成绩单上写了及格。谢谢您，下次我一定好好锻炼。",
    author: "体测困难户",
    school: "南大",
    time: "8小时前",
    likes: 654,
    comments: 88,
    hot: false,
  },
  {
    id: "f9",
    category: "食堂奇遇",
    emoji: "🍱",
    title: "食堂今天搞了个『暗黑料理盲盒』，有人抽到爆炒榴莲",
    excerpt: "本来是想整个活增加趣味，结果抽到榴莲的同学当场表演了一个原地瞳孔地震。不过据说挺好吃？评论区有没有勇士出来说说口感。",
    author: "干饭王中王",
    school: "浙工大",
    time: "10小时前",
    likes: 1520,
    comments: 640,
    hot: true,
  },
];

export const faqs: FaqItem[] = [
  {
    q: "校园吃瓜是一个什么样的网站？",
    a: "校园吃瓜是一个主打轻松向的校园闲聊围观社区。我们汇集来自各高校的宿舍趣闻、课堂名场面、食堂奇遇、社团搞事等趣味日常，让你课后没事来逛逛，看看别人班又在整什么活，边吃瓜边找到聊得来的同好。",
  },
  {
    q: "内容都是真实发生的吗？",
    a: "站内内容主要由同学投稿和互动整理而来，题材取材于真实校园生活，但部分表述经过艺术加工与娱乐化润色，纯属轻松搞笑的闲聊内容，请勿对号入座。我们倡导友善、欢乐的围观氛围。",
  },
  {
    q: "我也可以投稿分享趣事吗？",
    a: "当然可以！欢迎通过页面底部的投稿入口分享你身边发生的校园趣事、吃瓜段子或名场面。分享时可以隐去隐私信息，只保留欢乐的部分，让更多人一起乐一乐。",
  },
  {
    q: "浏览需要注册账号吗？",
    a: "浏览站内趣事和围观段子完全不需要注册，打开就能直接看。只有你想发表评论、参与互动或进行投稿时，才需要简单的登录，用来区分不同的同学身份。",
  },
  {
    q: "吃瓜内容会侵犯同学隐私吗？",
    a: "我们非常重视隐私保护。所有上榜内容在发布前都会进行脱敏处理，隐去真实姓名、学院班级等可识别信息，并鼓励同学们友善吃瓜，不做人身攻击，共同维护轻松快乐的围观氛围。",
  },
  {
    q: "怎样才能让自己的趣事上热榜？",
    a: "多分享有共鸣、有笑点的真实校园日常，内容越有生活气息越容易得到大家的点赞和评论。有趣的段子加上热烈的互动，就有机会冲上校园热榜，被更多人围观。",
  },
];

export const pollOptions = [
  { label: "食堂阿姨手抖，到底是故意的还是手滑？", votes: 4820, pct: 41 },
  { label: "大学最容易社死的瞬间是什么？", votes: 3670, pct: 31 },
  { label: "期末图书馆抢座到底有多难？", votes: 2130, pct: 18 },
  { label: "社团纳新到底值不值得参加？", votes: 1180, pct: 10 },
];

export const testimonials = [
  { name: "小野·大二", text: "每天睡前必刷的快乐源泉，比追剧还上头，看完总是能笑出鹅叫。" },
  { name: "阿哲·研一", text: "在这找到了好多同款经历，评论区全是懂哥懂姐，围观吃瓜还能认识同好。" },
  { name: "木子·大一", text: "刚入学啥都不懂，靠这些趣事快速融入了大学氛围，原来大家都这么会整活。" },
];